export default __webpack_public_path__ + "static/logo-4-764055c773976b178696493c07b86a44.png";